import React, { useEffect } from 'react';
import { useAppSelector } from '../hooks/useAppSelector';
import notificationService from '../services/notificationService';
import { Capacitor } from '@capacitor/core';

/**
 * When user is logged in (and on native), initialize push notifications and send FCM token to backend.
 * So the user receives notifications even when the app is closed or in background.
 */
export default function PushNotificationRegistration() {
  const { isAuthenticated, user } = useAppSelector((state) => state.auth);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        if (!Capacitor.isNativePlatform()) return;

        // Ask permission + register with OS/FCM as early as possible (first app open).
        // Token will be sent to backend after login.
        await notificationService.initialize();

        if (!cancelled && isAuthenticated && user) {
          await notificationService.sendPendingToken();
        }
      } catch (e) {
        console.warn('Push notification registration failed:', e);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [isAuthenticated, user?.id]);

  return null;
}
